import { useEffect } from 'react';
import {
    requestInitialData,
    listenMonitor
} from '../../channels/monitorChannel';

import { useLoadingStore } from '../../stores/useLoadingStore';

export function useFiltersBootstrap() {

    useEffect(() => {

        const {
            setLoadingBackdrop,
            setLoadingTxt,
            setLoadingClients,
            setLoadingVehicles,
            setLoadingDrivers,
            setLoadingLines,
            setLoadingTrips
        } = useLoadingStore.getState();

        // Enquanto ainda aguardamos a Home responder
        setLoadingBackdrop(true, false);

        setLoadingTxt('Aguardando dados da Home...', false);

        const unsubscribe =
            listenMonitor(({ tipo }) => {

                if (
                    tipo ===
                    'initial-data-start'
                ) {

                    setLoadingBackdrop(true, false);

                    setLoadingTxt('Recebendo dados da Home...', false);

                }

                if (
                    tipo ===
                    'initial-data-done'
                ) {

                    setTimeout(() => {
                        setLoadingClients(false, false);
                        setLoadingVehicles(false, false);
                        setLoadingDrivers(false, false);
                        setLoadingLines(false, false);
                        setLoadingTrips(false, false);

                        useLoadingStore
                            .getState()
                            .stopLoading(false);
                    }, 1000);

                }

            });

        // Listener primeiro,
        // request depois.
        requestInitialData();

        return unsubscribe;

    }, []);

}